import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { projectAreaGuard } from './guards/project-area.guard';
import { roleSelectionGuard } from './guards/role-selection.guard';
import { developerEntryGuard } from './guards/developer-entry.guard';
import { supportEntryGuard } from './guards/support-entry.guard';
import { adminAreaGuard } from './guards/admin-area.guard';
import { registeredApplicationsGuard } from './guards/registered-applications.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/entry/entry.page').then((m) => m.EntryPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'select-role',
    loadComponent: () => import('./pages/mode-select/mode-select.page').then((m) => m.ModeSelectPage),
    canActivate: [AuthGuard, roleSelectionGuard],
  },
  {
    path: 'support',
    canActivate: [supportEntryGuard],
    loadComponent: () =>
      import('./pages/entry-redirect-shell/entry-redirect-shell.page').then((m) => m.EntryRedirectShellPage),
    pathMatch: 'full',
  },
  {
    path: 'developer',
    canActivate: [developerEntryGuard],
    loadComponent: () =>
      import('./pages/entry-redirect-shell/entry-redirect-shell.page').then((m) => m.EntryRedirectShellPage),
    pathMatch: 'full',
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin-select/admin-select.page').then((m) => m.AdminSelectPage),
    canActivate: [AuthGuard, adminAreaGuard],
  },
  {
    path: 'registered-applications',
    loadComponent: () =>
      import('./pages/registered-applications/registered-applications.page').then(
        (m) => m.RegisteredApplicationsPage
      ),
    canActivate: [AuthGuard, registeredApplicationsGuard],
  },
  {
    path: 'users',
    loadComponent: () => import('./pages/users/users.page').then((m) => m.UsersPage),
    canActivate: [AuthGuard, adminAreaGuard],
  },
  {
    path: 'projects',
    loadComponent: () => import('./pages/projects/projects.page').then((m) => m.ProjectsPage),
    canActivate: [AuthGuard, projectAreaGuard],
  },
  {
    path: 'projects/:projectId/processing-results/:processId',
    loadComponent: () =>
      import('./pages/processing-result-detail/processing-result-detail.page').then(
        (m) => m.ProcessingResultDetailPage
      ),
    canActivate: [AuthGuard, projectAreaGuard],
  },
  {
    path: 'projects/:projectId/processing-results',
    loadComponent: () =>
      import('./pages/processing-results/processing-results.page').then((m) => m.ProcessingResultsPage),
    canActivate: [AuthGuard, projectAreaGuard],
  },
  {
    path: 'projects/:projectId/floors',
    loadComponent: () => import('./pages/floors/floors.page').then((m) => m.FloorsPage),
    canActivate: [AuthGuard, projectAreaGuard],
  },
  {
    path: 'projects/:projectId/floors/:floorId/drawings',
    loadComponent: () => import('./pages/drawings/drawings.page').then((m) => m.DrawingsPage),
    canActivate: [AuthGuard, projectAreaGuard],
  },
  {
    path: 'projects/:projectId/floors/:floorId/sessions',
    loadComponent: () => import('./pages/capture-sessions/capture-sessions.page').then((m) => m.CaptureSessionsPage),
    canActivate: [AuthGuard, projectAreaGuard],
  },
  {
    path: 'projects/:projectId/floors/:floorId/sessions/:sessionId/captures',
    loadComponent: () => import('./pages/captures/captures.page').then((m) => m.CapturesPage),
    canActivate: [AuthGuard, projectAreaGuard],
  },
  {
    path: 'no-access',
    loadComponent: () => import('./pages/no-access/no-access.page').then((m) => m.NoAccessPage),
    canActivate: [AuthGuard],
  },
];
